import { ButtonType } from '@ardoq/button';
import type { DropdownConfig } from '@ardoq/view-settings';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { ButtonIcon } from './ButtonIcon';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { SettingsBarContentPopover } from './SettingsBarContentPopover';

export const NewerDropdown = ({
  label,
  buttonText,
  isKeepOpen = false,
  options,
  isDisabled = false,
  isActive = false,
  id,
  clickNamespace,
  popoverText,
  popoverContent,
  requestOpen,
  onOpened,
  dropdownSize,
  maxDropdownSize,
  maxDropdownHeight,
  ...props
}: DropdownConfig) => {
  const asTextCombo = buttonText !== undefined;
  return (
    <SettingsBarContentPopover popoverContent={popoverContent}>
      <ButtonWithDropdown
        renderDropdownButton={
          asTextCombo
            ? undefined
            : (hostRef, isOpen, openModal) => (
                <ButtonIcon
                  ref={hostRef as React.RefObject<HTMLButtonElement>}
                  onClick={() => {
                    return options.length
                      ? openModal()
                      : undefined; /* don't show an empty dropdown with 0 options. */
                  }}
                  isActive={!isDisabled && (isActive || isOpen)}
                  isDisabled={isDisabled}
                  data-tooltip-text={
                    popoverText || popoverContent ? undefined : label
                  }
                  label={label}
                  popoverText={popoverContent ? undefined : popoverText}
                  {...props}
                />
              )
        }
        isActive={asTextCombo && !isDisabled && isActive}
        aria-label={asTextCombo ? `${label}: ${buttonText}` : undefined}
        tooltipText={
          asTextCombo && !(popoverText || popoverContent) ? label : undefined
        }
        options={options}
        isKeepOpen={isKeepOpen}
        isDisabled={isDisabled}
        data-click-id={id}
        clickNamespace={clickNamespace}
        dropdownSize={dropdownSize}
        minDropdownSize={DropdownSize.S}
        maxDropdownSize={maxDropdownSize ?? DropdownSize.M}
        maxDropdownHeight={maxDropdownHeight}
        requestOpen={requestOpen}
        onMenuOpen={onOpened}
        buttonType={ButtonType.GHOST}
      >
        {buttonText}
      </ButtonWithDropdown>
    </SettingsBarContentPopover>
  );
};
